import React from "react";
import { toast } from "sonner";
import { Copy, IdentificationBadge } from "@phosphor-icons/react";

export const PublicIdBadge = ({ publicId, size = "md", testId = "doudou-public-id" }) => {
  if (!publicId) return null;
  const small = size === "sm";

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(publicId);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = publicId;
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      if (!ok) {
        toast.error("Impossible de copier l'ID");
        return;
      }
    }
    toast.success(`ID ${publicId} copié !`);
  };

  return (
    <div className={`inline-flex items-center gap-2 rounded-2xl border border-dashed border-orange-300 bg-orange-50 ${small ? "px-2.5 py-1" : "px-4 py-2"}`}>
      <IdentificationBadge size={small ? 14 : 20} weight="duotone" className="text-orange-500" />
      {!small && <span className="text-xs font-bold uppercase tracking-wider text-orange-600">ID doudou</span>}
      <code className={`font-mono font-black tracking-[0.15em] text-stone-800 ${small ? "text-xs" : "text-lg"}`} data-testid={testId}>
        {publicId}
      </code>
      <button
        type="button"
        onClick={copy}
        aria-label="Copier l'ID"
        title="Copier l'ID"
        className="rounded-lg p-1 text-orange-500 transition-colors hover:bg-orange-100 hover:text-orange-700"
        data-testid={`${testId}-copy-btn`}
      >
        <Copy size={small ? 14 : 18} weight="bold" />
      </button>
    </div>
  );
};

export default PublicIdBadge;
